import React from 'react';
import { useTranslation } from 'react-i18next';
import StorefrontLayout from '../components/layout/StorefrontLayout';
import { applyContentLocaleToUrl } from '../utils/contentLocaleQuery';

const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:3001';

type SiteContent = {
  aboutTitle: string;
  aboutSubtitle: string;
  aboutBody: string;
  aboutImageUrl: string;
};

export default function AboutPage() {
  const { t, i18n } = useTranslation();
  const [content, setContent] = React.useState<SiteContent | null>(null);

  React.useEffect(() => {
    let cancelled = false;
    void (async () => {
      try {
        const res = await fetch(
          applyContentLocaleToUrl(
            `${API_BASE}/public/site-content`,
            i18n.resolvedLanguage || i18n.language,
          ),
        );
        if (!res.ok) return;
        const data = (await res.json()) as SiteContent;
        if (!cancelled) setContent(data);
      } catch {
        // ignore
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [i18n.language, i18n.resolvedLanguage]);

  return (
    <StorefrontLayout contentContained>
      <section className="py-4">
        <h1 className="text-3xl font-bold text-slate-900">
          {content?.aboutTitle?.trim() || t('public.about_fallback_title')}
        </h1>
        <p className="mt-2 text-sm text-slate-600">
          {content?.aboutSubtitle?.trim() || t('public.about_fallback_subtitle')}
        </p>
        {content?.aboutImageUrl ? (
          <img
            src={content.aboutImageUrl}
            alt={t('public.about_image_alt')}
            className="mt-4 h-64 w-full rounded-xl object-cover sm:h-80"
          />
        ) : null}
        <article className="prose prose-slate mt-5 max-w-none whitespace-pre-wrap text-sm">
          {content?.aboutBody?.trim() || t('public.about_fallback_body')}
        </article>
      </section>
    </StorefrontLayout>
  );
}

